/**
 * @param {{
 *   pageNumber: number | string; /* This is a user-readable number, not an index
 *   perPage: number | string;
 *   breedId: number | string;
 *   citySlug: string;
 * }} options
 * @returns {ResourceDefinition}
 */
export function reviewsTestimonialIndexResourceDefinition(options) {
  const { pageNumber, perPage, breedId, citySlug } = options;

  return {
    url: `/api/reviews/testimonials.json`,
    params: {
      page: pageNumber,
      per_page: perPage,
      breed_id: breedId,
      city_slug: citySlug
    }
  };
}

export function popularBreedsResourceDefinition(options = {}) {
  return {
    url: '/api/popular_breeds.json',
    defaultValue: {
      data: []
    },
    createFetchDataConfig: { ignoreRescueOn: [404] },
    params: {
      homepage: options.homepage || false
    }
  };
}
